// import { get } from 'lodash'

export default function () {
  const professionalParams = window.location.href.toString().split('/')
  this.crm = professionalParams[3]
  this.uf = professionalParams[4]

  if (window.location.href !== null) {
  }
  this.professionalQRCodeURL = window.location.href

  if (!this.crm && !this.uf) {
  }

  this.checkDomainOperator()
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/gadget/resources/mounted.js